import * as Tone from "tone"
import { mapValue } from "../../common/utils";
import { featuresContext as features } from "../features";
import waterTrack from "../../assets/water.mp3";
import fireTrack from "../../assets/fire.mp3";
import mineralTrack from "../../assets/rocks.mp3";
import airTrack from "../../assets/air.mp3";
import earthTrack from "../../assets/earth.mp3";
import plasmaTrack from "../../assets/plasma.mp3";
import forestTrack from "../../assets/forest.mp3";

const {speed, element } = features;


const backgroundTracks = {
  "fire": {
    backgroundTrack: fireTrack,
    feedbackDelay: 0.8,
    feedbackAmount: 0.5,
    reverbDecay: 2,
    reverbWet: 0.8,
    playbackRateRange: [0.6,1],
    volume: -20,
  },
  "mineral": {
    backgroundTrack: mineralTrack,
    feedbackDelay: "2n",
    feedbackAmount: 0.75,
    reverbDecay: 5,
    reverbWet: 0.8,
    playbackRateRange: [0.09,0.8],
    volume: -9,
  },
  "air": {
    backgroundTrack: airTrack,
    feedbackDelay: 0,
    feedbackAmount: 0,
    reverbDecay: 8,
    reverbWet: 0.8,
    playbackRateRange: [0.6,1],
    volume: -6,
  },
  "earth": {
    backgroundTrack: earthTrack,
    feedbackDelay: 0.05,
    feedbackAmount: 0.3,
    reverbDecay: 2,
    reverbWet: 0.8,
    playbackRateRange: [0.1,0.8],
    volume: -5,
  },
  "plasma": {
    backgroundTrack: plasmaTrack,
    feedbackDelay: 0.1,
    feedbackAmount: 0.1,
    reverbDecay: 2,
    reverbWet: 0.8,
    playbackRateRange: [0.1,1],
    volume: -7,
  },
  "forest": {
    backgroundTrack: forestTrack,
    feedbackDelay: 0,
    feedbackAmount: 0,
    reverbDecay: 2,
    reverbWet: 0.8,
    playbackRateRange: [0.2,1],
    volume: -2,
  },
  "water": {
    backgroundTrack: waterTrack,
    feedbackDelay: "5n",
    feedbackAmount: 0.4,
    reverbDecay: 2,
    reverbWet: 0.8,
    playbackRateRange: [0.1,0.3],
    volume: -8,
  }
}

let bg = backgroundTracks[element]

// player
const autoPanner = new Tone.AutoPanner({
  frequency: "1m",
  depth: 1,
  wet: 0.7,
})
const fxDelay = new Tone.FeedbackDelay({
  delayTime: bg.feedbackDelay,
  feedback: bg.feedbackAmount,
});
const fxReverb = new Tone.Reverb({
  decay: bg.reverbDecay,
  wet: bg.reverbWet,
});
const player = new Tone.Player({
  url: bg.backgroundTrack,
  loop: true,
  volume: -Infinity,
  playbackRate: mapValue(speed, 10, 40, bg.playbackRateRange[0], bg.playbackRateRange[1]),
  fadeIn: 1,
  fadeOut: 1,
});

player.chain(fxDelay, fxReverb, autoPanner, Tone.Destination);

export const startPlayer = () => {
  player.volume.rampTo(bg.volume, 2)
  player.start()
  autoPanner.start();
}

export const stopPlayer = () => {
  player.volume.rampTo(-Infinity, 4)
  player.stop()
  autoPanner.stop();
}